import { RouteRecordRaw } from 'vue-router'
export interface PermissionState {
  routes: RouteRecordRaw[];
  dynamicRoutes: RouteRecordRaw[];
  sidebarRoutes: RouteRecordRaw[];
  permissionsBtn: Array<any>;
}

export const state: PermissionState = {
  routes: [],
  dynamicRoutes: [],
  sidebarRoutes: [],
  permissionsBtn: []
}
